// What each territory does as a colony.
//   bonuses(card): what the colony gives while the player holds it (lost with it), applied like a card's printed
//                  bonuses (see PlayerState.BuildDelegates)
//   payout(card): what colonizing it gives once, as text for its card (e.g. "+3 food")
//   immediate(gameState, player, card): what colonizing it does once, as text for the move log (a choice, such as
//                  Autonomous Territory's, is asked as a decision)
// Amounts come from the card's age (see the territory classes in this folder).
const TerritoryNames = require('../Names/TerritoryNames');
const Territories = require('./Territories');

// Effects shared with other cards, needed lazily (they need the card definitions in turn)
const Gains = () => require('../../Moves/Colonization');

const TerritoryEffects = {
    [TerritoryNames.DevelopedTerritory]: {
        payout: (card) => `+${Territories.DevelopedTerritory.GetScienceCount(card.age)} science`,
        bonuses: (card) => ({ blueTokens: Territories.DevelopedTerritory.GetCubeCount(card.age), yellowTokens: Territories.DevelopedTerritory.GetCubeCount(card.age) }),
        immediate: (gameState, player, card) => {
            const science = Territories.DevelopedTerritory.GetScienceCount(card.age);
            player.science += science;
            return `+${science} science`;
        },
    },
    [TerritoryNames.HistoricTerritory]: {
        payout: (card) => `+${Territories.HistoricTerritory.GetCultureCount(card.age)} culture`,
        bonuses: (card) => ({ happyFaces: Territories.HistoricTerritory.GetHappyCount(card.age) }),
        immediate: (gameState, player, card) => {
            const culture = Territories.HistoricTerritory.GetCultureCount(card.age);
            player.culture += culture;
            return `+${culture} culture`;
        },
    },
    [TerritoryNames.InhabitedTerritory]: {
        payout: (card) => `${Territories.InhabitedTerritory.GetPopIncreaseCount(card.age)} free population increases`,
        bonuses: (card) => ({ yellowTokens: Territories.InhabitedTerritory.GetYellowCubeCount(card.age) }),
        // The new yellow tokens count straight away, so the population can grow from them (for free)
        immediate: (gameState, player, card) => {
            const times = Territories.InhabitedTerritory.GetPopIncreaseCount(card.age);
            const grown = Gains().IncreasePopulationFree(gameState, player, times, Territories.InhabitedTerritory.GetYellowCubeCount(card.age));
            return `${grown} population increase${grown === 1 ? '' : 's'} (free)`;
        },
    },
    [TerritoryNames.StrategicTerritory]: {
        payout: (card) => `draw ${Territories.StrategicTerritory.GetCardCount(card.age)} military cards`,
        bonuses: (card) => ({ strength: Territories.StrategicTerritory.GetMilitaryCount(card.age) }),
        immediate: (gameState, player, card) => {
            const count = Territories.StrategicTerritory.GetCardCount(card.age);
            const drawn = Gains().DrawMilitaryCards(gameState, player, count);
            return `draws ${drawn} military cards`;
        },
    },
    [TerritoryNames.VastTerritory]: {
        payout: (card) => `+${Territories.VastTerritory.GetFoodCount(card.age)} food`,
        bonuses: (card) => ({ yellowTokens: Territories.VastTerritory.GetYellowCubeCount(card.age), blueTokens: -1 }),
        immediate: (gameState, player, card) => {
            const food = Territories.VastTerritory.GetFoodCount(card.age);
            player.GainFood(food);
            return `+${food} food`;
        },
    },
    [TerritoryNames.WealthyTerritory]: {
        payout: (card) => `+${Territories.WealthyTerritory.GetResourceCount(card.age, card.version)} resources`,
        bonuses: (card) => ({ blueTokens: Territories.WealthyTerritory.GetBlueCubeCount(card.age) }),
        immediate: (gameState, player, card) => {
            const resources = Territories.WealthyTerritory.GetResourceCount(card.age, card.version);
            player.GainResources(resources);
            return `+${resources} resources`;
        },
    },
    [TerritoryNames.AutonomousTerritory]: {
        payout: () => '4 science, 5 resources, 6 food or 7 culture',
        bonuses: () => ({ civilActions: 1, militaryActions: 1, blueTokens: -2 }),
        immediate: (gameState, player) => {
            Gains().AskAutonomousChoice(gameState, player);
            return "chooses 4 science, 5 resources, 6 food or 7 culture";
        },
    },
};

module.exports = TerritoryEffects;
